import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from 'styled-components';
import { fadeIn, fadeInSlideUp, fadeInSlideDown, fadeInSlideLeft, fadeInSlideRight, bounceIn, bounceInDown, bounceInLeft, bounceInRight, bounceInUp, bounceUpAndDown, zoomIn } from './mixins';
export var Animation = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  switch (props.name) {
    case 'fadeIn':
      return fadeIn(props);

    case 'fadeInSlideDown':
      return fadeInSlideDown(props);

    case 'fadeInSlideUp':
      return fadeInSlideUp(props);

    case 'fadeInSlideLeft':
      return fadeInSlideLeft(props);

    case 'fadeInSlideRight':
      return fadeInSlideRight(props);

    case 'bounceIn':
      return bounceIn(props);

    case 'bounceInDown':
      return bounceInDown(props);

    case 'bounceInLeft':
      return bounceInLeft(props);

    case 'bounceInRight':
      return bounceInRight(props);

    case 'bounceInUp':
      return bounceInUp(props);

    case 'bounceUpAndDown':
      return bounceUpAndDown(props);

    case 'zoomIn':
      return zoomIn(props);

    default:
      return fadeIn(props);
  }
});
export var AnimationFixed = styled(Animation)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: ", ";\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  outline: 0;\n  display: block;\n  pointer-events: none;\n"])), function (_ref) {
  var isDesktop = _ref.isDesktop;
  return isDesktop ? 'absolute' : 'fixed';
});
export var AnimationOnTop = styled(AnimationFixed)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  z-index: 1051;\n  top: auto;\n  pointer-events: auto;\n"])));